// extracted by mini-css-extract-plugin
export default {"errorPageContainer":"ErrorPage_errorPageContainer__Sk4SN","errorBtn":"ErrorPage_errorBtn__y0TM4","title":"ErrorPage_title__eSBmp"};